import React, { FunctionComponent } from "react";
import { Link } from "gatsby";
import { Layout } from "../components/layout";
import { PageHeader } from "../components/pageHeader";

export const ContactSuccess: FunctionComponent = () => {
  return (
    <Layout>
      <PageHeader
        title="Thank you"
        deck="Your message has been received. I will get back to you as soon as I can!"
      />
      <div className="px-gutter-sm pb-14 md:px-gutter">
        <Link to="/" className="btn-primary">
          Back to the home page
        </Link>
      </div>
    </Layout>
  );
};

export default ContactSuccess;
